<template>
  <div class="TableBox">
    <search-template page_name="收入表" :timeMonth='timeMonth' source="income" @search_event='search_event'></search-template>
    <div class="operationUploadBox clear" style="margin-top:5px;">
      <div class="operationUpload">
        <div class="batchDelete" style="background:#d51414;border-color:#d51414" @click="batchDelete">批量删除</div>
        <div class="batchDelete" style="background:#FF9B3B;border-color:#FF9B3B;" @click="clearSelection">清空选中</div>
        <a class="fileTemplate" href='https://order-consumption-system.oss-cn-beijing.aliyuncs.com/templates/%E9%94%80%E5%94%AE-%E6%94%B6%E5%85%A5%E6%95%B0%E6%8D%AE%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'>收入表导入模板</a>
        <a class="fileTemplate" href='https://order-consumption-system.oss-cn-beijing.aliyuncs.com/templates/%E9%94%80%E5%94%AE-%E7%BA%A2%E5%AD%97%E5%8F%91%E7%A5%A8%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'>红字发票导入模板</a>
        <el-upload style="display: inline-block;float: left;" ref="upload" :action="URL.BASEURL + URL.salerOrderImportValidate" :on-success="uploadSuccess" :on-error="uploadError" :on-progress='uploadProgress' :data="{
                    admin_id: JSON.parse(this.$cookie.getCookie('userInfo')).admin_id,
                    ttl: JSON.parse(this.$cookie.getCookie('userInfo')).ttl,
                    sign: JSON.parse(this.$cookie.getCookie('userInfo')).sign,
                }" :show-file-list='false' :auto-upload="true" accept=".xlsx,.csv">
          <div class="batchDelete">收入表导入</div>
        </el-upload>
        <el-upload style="display: inline-block;float: left;" ref="upload" :action="URL.BASEURL + URL.orderImportSecond" :on-success="uploadSuccess" :on-error="uploadError" :on-progress='uploadProgress' :data="{
                    admin_id: JSON.parse(this.$cookie.getCookie('userInfo')).admin_id,
                    ttl: JSON.parse(this.$cookie.getCookie('userInfo')).ttl,
                    sign: JSON.parse(this.$cookie.getCookie('userInfo')).sign,
                    type: 4
                }" :show-file-list='false' :auto-upload="true" accept=".xlsx,.csv">
          <div class="batchDelete">红字发票导入</div>
        </el-upload>
      </div>
      <button class="batchDelete" style="float:right;font-size:12px;" @click="orderUpdateFlag=true" v-if="userInfo.role_id == 11 || userInfo.role_id == 12">批量修改</button>
      <button class="batchDelete" style="float:right;font-size:12px;" @click="batchUpdateFlag=true" v-if="userInfo.role_id == 11">批量修改（订单最终收入金额）</button>
      <div class="refreshIcon batchDelete" @click="init({page:1})">
        刷新
        <i class="el-icon-refresh"></i>
      </div>
      <div class="batchDelete" @click="init({page:1,exportFlag:true})">导出</div>
    </div>
    <ux-grid class="uxGridBox" ref="plxTable" :height="height" :checkboxConfig="{checkMethod: selectable, highlight: true}" @selection-change="selectionChange" @table-body-scroll="scroll" show-footer-overflow="tooltip" show-overflow="tooltip" keep-source :edit-config="{trigger: 'manual', mode: 'row'}" size="mini">
      <ux-table-column type="checkbox" align="center" fixed="left" width="40" />
      <ux-table-column v-for="item in columns" :key="item.id" :resizable="item.resizable" :field="item.prop" :title="item.label" :width="item.width" show-header-overflow='tooltip' :fixed="item.fixed" :edit-render="item.editRender?true:false" align="center" />
      <ux-table-column title="状态" align="center" minWidth="60" fixed="right" field="describe">
        <template v-slot="{ row }">
          <span v-if="row.status<3">未锁单</span>
          <div v-else>
            <span v-if="row.verify_status == 0">未修改</span>
            <span v-if="row.verify_status == 1">待商务审核</span>
            <span v-if="row.verify_status == 2">商务通过</span>
            <span v-if="row.verify_status == 3">商务驳回</span>
            <span v-if="row.verify_status == 4">财务通过</span>
            <span v-if="row.verify_status == 5">财务驳回</span>
          </div>
        </template>
      </ux-table-column>
      <ux-table-column :resizable='true' title="开票状态" align="center" minWidth="60" fixed="right" field="describe">
        <template v-slot="{ row }">
          <span v-if="row.invoice_status == -2">已作废</span>
          <span v-else-if="row.invoice_status == 1">已提审</span>
          <span v-else-if="row.invoice_status == 2">商务通过</span>
          <span v-else-if="row.invoice_status == 3">商务驳回</span>
          <span v-else-if="row.invoice_status == 4">财务通过</span>
          <span v-else-if="row.invoice_status == 5">财务驳回</span>
          <span v-else>未申请</span>
        </template>
      </ux-table-column>
      <ux-table-column :resizable='true' title="结算单状态" align="center" minWidth="60" fixed="right" field="describe">
        <template v-slot="{ row }">
          <span v-if="row.statements_status == -2">已作废</span>
          <span v-else-if="row.statements_status == -1">已保存</span>
          <span v-else-if="row.statements_status == 1">已提审</span>
          <span v-else-if="row.statements_status == 2">商务通过</span>
          <span v-else-if="row.statements_status == 3">商务驳回</span>
          <span v-else-if="row.statements_status == 4">财务通过</span>
          <span v-else-if="row.statements_status == 5">财务驳回</span>
          <span v-else>未申请</span>
        </template>
      </ux-table-column>
      <ux-table-column title="操作" align="center" minWidth="80" fixed="right" field="describe">
        <template v-slot="{ row }">
          <span style="color:#ff9b3c;cursor: pointer;margin-right:5px;" v-if="row.status>=3&&(row.verify_status==1||row.verify_status==2)" @click="delVerifyOrder(row)">撤销</span>
          <span v-else>
            <span style="color:#5B7BFE;cursor: pointer;margin-right:5px;" v-if="row.enable_edit==1" @click="editRowEvent(row)">编辑</span>
          </span>
          <span style="color:#5B7BFE;cursor: pointer;" @click="order_id=row.order_id;record_id=row.id;journalFlag=true;">记录</span>
        </template>
      </ux-table-column>
    </ux-grid>
    <div ref="pagination" class="paginationBox" style="height: 30px;">
      <el-pagination small background :current-page="page" :page-size="page_size" @current-change="handleCurrentChange" layout="total, prev, pager, next, jumper" :total="total" />
    </div>
    <el-dialog title="编辑" :visible.sync="editFlag" width="70%" top="10vh" :close-on-click-modal='false'>
      <income-edit v-if="editFlag" :editDataTotal='editData' @cancelToast='cancelToast' @emit_refresh="emit_refresh"></income-edit>
    </el-dialog>
    <!-- 批量修改（订单最终收入金额） -->
    <el-dialog title="批量修改（订单最终收入金额）" :visible.sync="batchUpdateFlag" width="400px" top="10vh" :close-on-click-modal='false'>
      <batch-update v-if="batchUpdateFlag" @closeToast='()=>{batchUpdateFlag=false}' @updateList="batchUpdateFlag=false;init({page:1})"></batch-update>
    </el-dialog>
    <!-- 查看日志 -->
    <el-dialog title="订单记录" :visible.sync="journalFlag" width="60%" top="10vh" :close-on-click-modal='false'>
      <journal v-if="journalFlag" @cancelToast='cancelToast' :order_id='order_id' :record_id='record_id'></journal>
    </el-dialog>
    <!-- 批量修改（客户后返返点金额） -->
    <el-dialog title="批量修改" :visible.sync="orderUpdateFlag" width="400px" top="10vh" :close-on-click-modal='false'>
      <order-update v-if="orderUpdateFlag" @closeToast='()=>{orderUpdateFlag=false}' @updateList="orderUpdateFlag=false;init({page:1})"></order-update>
    </el-dialog>
  </div>
</template>
<script>
import journal from '../orderJournal'
import batchUpdate from './batchUpdate'
import orderUpdate from './orderUpdate'
import columnsJson from '../json/income.js'
import incomeEdit from './incomeEdit'
import searchTemplate from '../searchTemplate.vue'
export default {
  components: {
    incomeEdit,
    batchUpdate,
    orderUpdate,
    journal,
    searchTemplate
  },
  data () {
    return {
      height: 0,
      columns: [],//表头
      scrollTop: 0,
      loading: false,
      timeMonth: [],
      editData: {},
      editFlag: false,
      multipleSelection: [],
      multipleSelection1: {},
      userInfo: {},
      batchUpdateFlag: false,
      orderUpdateFlag: false,
      order_id: '',
      journalFlag: false,
      record_id: '',
      page: 1,
      page_size: 100,
      total: 0,
      search_data: [],
      selectionList: [],
      flag: false
    }
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    var date = new Date();
    if (date.getMonth() === 0) { // 默认值为上个月份；月份为 0 时处理跨年问题
      this.timeMonth = [(date.getFullYear() - 1) + '-' + '12'];
    } else {
      this.timeMonth = [date.getFullYear() + '-' + ((date.getMonth()) < 10 ? '0' + (date.getMonth()) : (date.getMonth()))];
    }
    this.columns = columnsJson
  },
  mounted () {
    this.$nextTick(() => {
      this.computeGridHeight()
      window.addEventListener('resize', this.computeGridHeight, { passive: true })
    })
    this.init({ page: 1 })
  },
  beforeDestroy () {
    try {
      window.removeEventListener('resize', this.computeGridHeight)
    } catch (e) {}
  },
  methods: {
    computeGridHeight () {
      this.$nextTick(() => {
        try {
          const viewportH = window.innerHeight || document.documentElement.clientHeight
          const gridEl = this.$refs.plxTable && this.$refs.plxTable.$el
          const pagEl = this.$refs.pagination
          if (!gridEl) return
          const gridTop = gridEl.getBoundingClientRect().top
          const pagH = pagEl ? pagEl.offsetHeight : 56
          const gap = 16
          const footer = 29
          let h = Math.floor(viewportH - gridTop - pagH - gap - footer)
          if (h < 300) h = 300
          this.height = h
        } catch (e) {
          const h = document.documentElement.clientHeight - 320
          this.height = h > 400 ? h : 400
        }
      })
    },
    search_event (data) {
      this.search_data = data;
      this.init({ page: 1 })
    },
    batchDelete () {//批量删除
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        this.$message({
          message: '未选择要删除的订单',
          type: 'warning'
        })
        return
      }
      this.$confirm('确定要删除所选中订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var arr = [];
        this.multipleSelection.forEach((item) => {
          arr.push(item.id)
        })
        this.$loading(this.$loadingConfig)
        this.$axios.post(this.URL.BASEURL + this.URL.orderIncomeBatchDel, {
          id_list: arr
        }).then((res) => {
          var res = res.data;
          if (res && res.errno == 0) {
            this.$message({
              message: '删除成功！',
              type: 'success'
            })
            this.init({ page: 1 })
          } else {
            this.$loading(this.$loadingConfig).close()
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
          this.$loading(this.$loadingConfig).close()
        })
      }).catch(() => {
      });
    },
    emit_refresh () {//编辑成功
      this.editFlag = false;
      this.init({ page: this.page })
    },
    cancelToast () {
      this.journalFlag = false;
      this.editFlag = false;
    },
    editRowEvent (row) {//编辑
      this.editFlag = true;
      this.editData = row;
      this.editData.if_public = this.editData.if_public == '是' ? true : null
    },
    uploadSuccess (res, file, fileList) {
      let _this = this;
      this.$loading(this.$loadingConfig).close()
      if (res.errno == 0) {
        this.$alert('导入成功！', '成功', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          callback: action => {
            this.init({ page: 1 })
          }
        });
      } else {
        var errHint = ''
        if (Array.isArray(res.rst.error)) {
          errHint = '<p>有误字段：</p><ul>'
          res.rst.error.forEach((item) => {
            errHint += `<li>第${item.row}行：${item.error.join(',')}</li>`
          })
          errHint += '</ul>'
        } else {
          errHint = res.rst.error
        }
        this.$alert(errHint, res.err, {
          dangerouslyUseHTMLString: true,
          confirmButtonText: res.errno == 6001 ? '确定' : '确定导入',
          cancelButtonText: '取消',
          showCancelButton: res.errno == 6001 ? false : true,
        }).then(() => {
          if (res.errno == 6009) {
            _this.salerOrderImportConfirm(1)
          }
        }).catch(() => {
          if (res.errno == 6009) {
            _this.salerOrderImportConfirm(0)
          }
        });
      }
    },
    uploadError (err, file, fileList) {
      this.$loading(this.$loadingConfig).close()
      this.$alert('上传失败', '服务器错误', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        callback: action => {
        }
      });
    },
    uploadProgress () {//上传中
      this.$loading(this.$loadingConfig);
    },
    salerOrderImportConfirm (confirm_type) {//收入二次确认导入
      this.$loading(this.$loadingConfig);
      this.$axios.post(this.URL.BASEURL + this.URL.salerOrderImportConfirm, {
        confirm: confirm_type
      }).then((res) => {
        var res = res.data;
        this.$loading(this.$loadingConfig).close()
        if (res && res.errno == 0) {
          if (confirm_type == 1) {
            this.init({ page: 1 })
          }
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close()
      })
    },
    clearSelection () {//清空选中
      this.$refs.plxTable.clearSelection();
      this.multipleSelection1 = {};
      this.multipleSelection = [];
      this.selectionList = []
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach((row, index) => {
          this.$refs.plxTable.toggleRowSelection([
            {
              row: row,
              selected: true
            }
          ])
          if (index == rows.length - 1) {
            this.flag = true
          }
        });
      }
    },
    handleCurrentChange (val) {
      this.init({ page: val, selection: 'clear' })
    },
    init ({ page, exportFlag, selection }) {
      if (!selection || selection != 'clear') {
        this.clearSelection()
      }
      var params = {
        page: page,
        pagesize: this.page_size,
        month: this.timeMonth,
        is_statements: 0,
      }
      if (exportFlag) {
        params.page = 1;
        params.pagesize = 10000
      } else {
        page = page ? page : 1;
        params.page = page;
        this.page = page;
      }
      if (this.search_data.length == 0) {
        params.month = this.timeMonth
      } else {
        this.search_data.forEach((item) => {
          if (item.property == 'if_public' || item.property == 'is_refund') {
            params[item.property] = item.values == '是' ? 1 : null
          } else {
            params[item.property] = item.values
          }
        })
      }
      this.$loading(this.$loadingConfig);
      this.$axios.get(this.URL.BASEURL + this.URL.orderIncomeList, {
        params
      }).then((res) => {
        var res = res.data;
        this.$loading(this.$loadingConfig).close()
        if (res && res.errno == 0) {
          var data = res.rst;
          if (exportFlag) {
            this.$exportOrder({ source: 'income', dataList: data.data, name: '收入表' })
          } else {
            this.total = data.pageInfo.total;
            this.datas = data.data // 知道为啥datas不在 data()方法里面定义吗？嘻嘻
            this.$refs.plxTable.reloadData(this.datas)
            this.$nextTick(() => {
              this.computeGridHeight()
              if (this.multipleSelection1['page_' + this.page] && this.multipleSelection1['page_' + this.page].length != 0) {
                var rows = [], arr = []
                this.multipleSelection1['page_' + this.page].forEach((item) => {
                  arr.push(item.id)
                })
                rows = this.datas.filter((v) => {
                  return arr.indexOf(v.id) != -1
                })
                this.flag = false
                this.toggleSelection(rows)
              } else {
                this.flag = true
              }
            })
          }
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close()
      })
    },
    scroll ({ scrollTop, scrollLeft }) {
      this.scrollTop = scrollTop
    },
    selectable ({ row }) {//选择表格限制条件
      return row.verify_status != 1 && row.verify_status != 2
    },
    selectionChange (row) {// 选中的行
      this.selectionList = row;
      if (this.flag) {
        this.multipleSelection1['page_' + this.page] = this.selectionList;
        this.multipleSelection = [];
        for (var i in this.multipleSelection1) {
          this.multipleSelection = this.multipleSelection.concat(this.multipleSelection1[i])
        }
      }
    },
    delVerifyOrder (data) {
      this.$confirm(data.is_batch == 1 ? '此订单为批量修改，撤销操作将会取消本次批量修改内容，确定要撤销此次提审吗?' : '确定要撤销此次提审吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$loading(this.$loadingConfig);
        this.$axios.post(this.URL.BASEURL + this.URL.delVerifyOrder, {
          order_id: data.order_id,
          type: 1
        }).then((res) => {
          var res = res.data;
          if (res && res.errno == 0) {
            this.init({ page: 1 })
          } else {
            this.$loading(this.$loadingConfig).close();
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
          this.$loading(this.$loadingConfig).close();
        })
      }).catch(() => {
      });
    },
  },
}
  </script>
  <style lang="scss" scoped>
@import "@/assets/css/tableStyle.scss";
.topOperation {
  display: flex;
  align-items: top;
  .screenBox {
    flex: 1;
  }
}
.TableBox {
  padding: 15px;
  background: #fff;
  margin-top: 15px;
}
.operationUpload,
.operationUploadBox {
  display: flex;
  align-items: center;
}
.operationUpload {
  flex: 1;
}
.fileTemplate {
  font-size: 12px;
  margin-right: 10px;
  text-decoration: underline;
  margin: 8px 10px 0 0;
  color: #5b7bfe;
  display: block;
}
.batchDelete {
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #5b7bfe;
  background: #5b7bfe;
  color: #fff;
  margin-right: 16px;
  cursor: pointer;
  padding: 0 4px;
}
.uxGridBox {
  margin-top: 15px;
}
.refreshIcon {
  margin-right: 10px;
  background: #67c23a;
  border-color: #67c23a;
}
</style>


// WEBPACK FOOTER //
// src/components/Order/saler/incomeTable.vue